import axios from 'axios';
import '../config.js';

const appendParam = (params, key, value) => {
  if (value === null || value === undefined || value === '') {
    return;
  }
  params.append(key, String(value));
};

const withAppProvider = (url, appProviderId) => {
  if (appProviderId !== null && appProviderId !== undefined && appProviderId !== '') {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}appProviderId=${appProviderId}`;
  }
  return url;
};

const buildLogsQueryString = (query = {}) => {
  const params = new URLSearchParams();
  appendParam(params, 'initDate', query.initDate);
  appendParam(params, 'endDate', query.endDate);
  appendParam(params, 'page', Number.isFinite(Number(query.page)) ? Number(query.page) : 0);
  appendParam(params, 'pageSize', Number.isFinite(Number(query.pageSize)) ? Number(query.pageSize) : 20);
  appendParam(params, 'membership', query.membership);
  return params.toString();
};

const buildCountQueryString = (query = {}) => {
  const params = new URLSearchParams();
  appendParam(params, 'initDate', query.initDate);
  appendParam(params, 'endDate', query.endDate);
  appendParam(params, 'membership', query.membership);
  return params.toString();
};

/**
 * @param {import('./types/supportTileLogs').SupportTileLogsRequest} payload
 * @returns {Promise<import('./types/supportTileLogs').SupportTileLog[]>}
 */
export const getSupportTileLogs = async (payload, appProviderId) => {
  const token = localStorage.getItem('token');
  const qs = buildLogsQueryString(payload.query || {});
  const baseUrl =
    global.config.url +
    `/support/tileslog/${encodeURIComponent(String(payload.tileId))}/${payload.customerId}${qs ? `?${qs}` : ''}`;
  const url = withAppProvider(baseUrl, appProviderId);

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return Array.isArray(response.data) ? response.data : [];
};

/**
 * @param {import('./types/supportTileLogs').SupportTileLogsRequest} payload
 * @returns {Promise<number>}
 */
export const getSupportTileLogsCount = async (payload, appProviderId) => {
  const token = localStorage.getItem('token');
  const qs = buildCountQueryString(payload.query || {});
  const baseUrl =
    global.config.url +
    `/support/tileslogcount/${encodeURIComponent(String(payload.tileId))}/${payload.customerId}${qs ? `?${qs}` : ''}`;
  const url = withAppProvider(baseUrl, appProviderId);

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return Number(response.data) || 0;
};

const supportTileLogsApi = {
  getSupportTileLogs,
  getSupportTileLogsCount,
};

export default supportTileLogsApi;
